<template>
	<div class="box" lang="es">
		<h3>Acuerdo de usuario V720 Pro</h3>
		<div class="vhtml" v-html="htmlText" ></div>
	</div>
</template>

<script>
	import esUser from '../assets/js/esUser.js'
	export default {
		data() {
			return {
				htmlText: esUser,
			}
		},
	}
</script>

<style lang="less" scoped>
	*{
		margin-bottom: 40px;
	}
	h3 {
		text-align: center;
	}
	.box {
		padding: 0px 20px 30px !important;
		margin-top: 50px;
		background: #FFF;
		color: #000;
		font-size: 16px;
	}
	.vhtml /deep/ p {
		margin-bottom: 20px;
		color: #333;
	}
	.vhtml /deep/ .subTitle {
		color: #000;
		font-weight: bold;
	}
</style>